import { type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/shared/api';

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  // 싱글턴을 provide 한다 — `attachAuthCacheReset`(queryClient.ts)이 비우는 대상과
  // React 트리가 쓰는 대상이 달라 세션 만료·크로스탭 로그아웃의 캐시 초기화가 죽어 있었다.
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
